import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import useViewport from 'Hooks/useViewport';

const PillFilters = ({
  options,
  value,
  onChange,
  mobilePills,
}) => {
  const { isAboveMd, isBelowLg } = useViewport();

  const PillFilter = option =>
    <button className={`pill-filter-container ${value === option.type ? 'selected' : ''}`} key={option.type} onClick={() => onChange(option.type)}>
      {option.name}
    </button>;

  return (
    <React.Fragment>
      {(isAboveMd || mobilePills) &&
        <div className="bundle-pill-filters-container d-flex">
          {options.map(option => PillFilter(option))}
        </div>
      }
      {isBelowLg && !mobilePills &&
        <div className="filters-container">
          <div className="mr-3"><FormattedMessage id="pillfilters.type" defaultMessage="Type" />:</div>
          <div className="dropdown-container type-filter">
            <select value={value} onChange={e => onChange(e.target.value)}>
              {options.map(option =>
                <option
                  key={option.type}
                  value={option.type}
                >
                  {option.name}
                </option>,
              )}
            </select>
          </div>
        </div>
      }
    </React.Fragment>
  );
};


PillFilters.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    name: PropTypes.string,
  })),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  mobilePills: PropTypes.bool,
};

PillFilters.defaultProps = {
  options: [],
  value: '',
  mobilePills: false,
};

export default PillFilters;
